// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__2U80V","image":"Card_image__VZTa-"};